// extracted by mini-css-extract-plugin
export default {"container":"order-limitation-table_container__avY+J"};